import {InsightsMetricSelectOption, MetricValue} from '../analytics.types';
import _fromPairs from 'lodash/fromPairs';

export default function getRemoteMetricKey<T>(
  availableOptions: InsightsMetricSelectOption<MetricValue>[],
  key: string | undefined,
) {
  if (!key) return null;

  const optionsMapping = _fromPairs(
    availableOptions.map((item) => [item.label, item.value]),
  ) as Record<string, MetricValue>;

  return (optionsMapping[key] ??
    (Object.values(optionsMapping).includes(key as MetricValue) ? key : null)) as T;
}
